import api from "./api";

/**
 * GET services by category
 * @param {Number} categoryId
 * @param {Number} page
 * @param {Number} pageSize
 * @param {Number} lat
 * @param {Number} lng
 */
export const fetchServicesByCategory = ({
  categoryId,
  page = 1,
  pageSize = 10,
  lat,
  lng,
}) => {
  return api.get(`/services/website/by_category/${categoryId}`, {
    params: {
      page,
      pageSize,
      lat,
      lng,
    },
  });
};

export const fetchServiceByGuestUser = ({ serviceId, latitude, longitude }) => {
  return api.post(`/services/by-guest-user/website/${serviceId}`, {
    latitude,
    longitude,
    allowed: true,
    error: null,
  });
};

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const selectServiceTypeApi = (serviceTypeId) => {
  const token = localStorage.getItem("access_token");

  return api.get(
    `/services-selection/${serviceTypeId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
